<app-consensus-summary [primaryTicker]="primaryTicker"></app-consensus-summary>
<hr class="tpr-company-divider" />
<app-tpr-company-broker-grid
  [primaryTicker]="primaryTicker"
  [isTabVisible]="isTabVisible"
></app-tpr-company-broker-grid>
